import * as type from '../actions/types';

const initialState = {
  redirect: false,
  invalid: [],
};

const invalidUrls = (state = initialState, action) => {
  switch (action.type) {
    case type.SET_INVALID_URLS:
      return {
        ...state,
        redirect: true,
        invalid: action.invalid,
      };
    case type.RESET_INVALID_URLS:
      return {
        ...state,
        redirect: false,
        invalid: [],
      };
    default:
      return state;
  }
};

export default invalidUrls;
